module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isStages) ? _c('div', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("All Stages")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.stages), function(eachStage, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eachStage.next))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eachStage.text))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.editStage(key)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-times-circle",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.removeStage(key)
        }
      }
    })])])
  }))])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Next Stage")]), _vm._v(" "), _c('th', [_vm._v("Message")]), _vm._v(" "), _c('th', [_vm._v("Edit")]), _vm._v(" "), _c('th', [_vm._v("Delete")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0995696d","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateSmsApp/allstages.vue
// module id = LaFP
// module chunks = 1